import React, { useState } from 'react';
import { Button, Drawer, Tooltip } from 'antd';
import { EditIcon } from 'lucide-react';
import ClosedRequest from '../pages/enquiry/ClosedRequest';

const AddDrawer = (props) => {
    const { title, action, content, sizes, open, setOpen, btnType, status, remark } = props

    const showDrawer = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };

    return (
        <div className='add_modal'>

            {btnType === "link" ? <Tooltip title="Edit"> <EditIcon size={20} onClick={showDrawer} /></Tooltip> : <Button type="primary" onClick={showDrawer}>
                {action}
            </Button>}
            <Drawer
                width={sizes}
                title={title}
                closable={{ 'aria-label': 'Close Button' }}
                onClose={onClose}
                open={open}
            >
                {status === "CLOSED" ? <ClosedRequest remark={remark} />
                    : content}
            </Drawer>
        </div>
    );
};

export default AddDrawer